import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import { ProgressSpinner } from 'primereact/progressspinner';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Spinner } from 'react-bootstrap';

import { useProfileContext } from '../../../Contexts/ProfileContext';
import { toggleDialog, setRerenderSubscription, setRerender, setShowPaymentPlans } from '../../../../redux/Slices/Global/globalSlice';
import { useScrollLoadingContext } from '../../../Contexts/ScrollLoadingContext';
import { useCustomToast } from '../../../Contexts/ToastContext';

import FeaturesList from './FeaturesList';
import BillingCards from './PricingSwitchCard';
import { TOOLTIP_OPTIONS } from '../../../../config/global';
import { Tooltip } from 'primereact/tooltip';
import { useMutation } from 'react-query';
import { changePlan, createCheckoutSession } from '../../../../queries';

function UpgradeDialog({ plan }) {
    const { t } = useTranslation();
    const { paymentData, onScreenChange, numberOfScreens, setSelectedPricing, isUpgrade, selectedPricing, setSelectedPackage, selectedPackage } = useProfileContext();
    const dispatch = useDispatch();
    const { openDialog, packages, companyDetails } = useSelector((state) => state.global);
    const { ids, setIds, data, pageNum, isFetching, setPath } = useScrollLoadingContext();
    const { showToast } = useCustomToast();
    const [billing, setBilling] = useState("annually"); // or "monthly"

    const [selectDevice, setSelectDevice] = useState();
    const [isValid, setIsValid] = useState(true);
    const [isActive, setIsActive] = useState(companyDetails?.subscription?.status == "ACTIVE");
    const [showDeviceList, setShowDeviceList] = useState();
    const [actionLoading, setActionLoading] = useState(false);
    let isFree = companyDetails?.package?.prices[0]?.price === 0;

    const hasStripeSubscription = !!companyDetails?.subscription?.stripe_subscription_id;

    const closeDialog = () => {
        setIds([]);
        dispatch(toggleDialog("upgrade"))
    }

    const onPackageChange = (isEnable, _package) => {
        if (isEnable) {
            return;
        } else {
            setSelectedPackage(_package)
        }
    }

    const onDevicesChange = (e) => {
        let selectedDevices = [...ids];

        if (e.checked)
            selectedDevices.push(e.value);
        else
            selectedDevices.splice(selectedDevices.indexOf(e.value), 1);

        setIds(selectedDevices);
    }

    // For existing Stripe subscribers — update the subscription directly.
    const changePlanMutation = useMutation(changePlan, {
        onSuccess: (result) => {
            dispatch(setRerenderSubscription(true));
            dispatch(setRerender(true));
            dispatch(setShowPaymentPlans(false));
            setActionLoading(false);
            dispatch(toggleDialog("upgrade"));
            showToast('success', t('payment.toast_plan_changed'), result?.data?.msg ?? t('payment.plan_updated_success'));
        },
        onError: (error) => {
            showToast('error', t('payment.toast_plan_change_failed'), error?.response?.data?.message ?? t('payment.plan_change_error'));
            setActionLoading(false);
        },
    });

    // For new Stripe subscribers — redirect to hosted Checkout.
    const checkoutMutation = useMutation(createCheckoutSession, {
        onSuccess: ({ checkout_url }) => {
            window.location.href = checkout_url;
        },
        onError: (error) => {
            showToast('error', t('payment.toast_checkout'), error?.response?.data?.message ?? t('payment.checkout_error'));
            setActionLoading(false);
        },
    });

    const upgrade = () => {
        if (!isValid) return;

        setActionLoading(true);

        if (hasStripeSubscription) {
            changePlanMutation.mutate({
                packageId:       selectedPackage?.id,
                period:          selectedPricing?.period,
                numberOfDevices: numberOfScreens,
                devicesList:     ids,
            });
        } else {
            // Redirect through Stripe Checkout; PaymentDialog is skipped.
            checkoutMutation.mutate({
                packageId:       selectedPackage?.id,
                period:          selectedPricing?.period,
                numberOfDevices: numberOfScreens,
                devicesList:     ids,
            });
        }
    }

    useEffect(() => {
        setPath(`/company/devices/list?page=${pageNum}&per_page=15`)

        let index = packages.findIndex(obj => obj.id === plan?.id)
        if (index + 1 < packages.length)
            ++index

        // setSelectedPackage(packages[index])
        // setSelectedPricing(packages[index]?.prices[0])

        return () => {
            setPath("")
        }
    }, [])

    useEffect(() => {

        let index = packages.findIndex(obj => obj.id === plan?.id)
        if (index + 1 < packages.length)
            ++index

        // setSelectedPackage(packages[index])
        setSelectedPackage(plan)

        // setSelectedPricing(plan?.prices[0])

        return () => {
            setPath("")
        }
    }, [plan])

    useEffect(() => {
        if (ids?.length > 0 && ids?.length !== numberOfScreens)
            setIsValid(false)
        else {
            setIsValid(true)
        }
        // }, [ids])
    }, [ids, numberOfScreens])


    useEffect(() => {
        setShowDeviceList(numberOfScreens < data.length)
    }, [data, numberOfScreens])


    useEffect(() => {
        if (ids?.length > 0 && ids?.length < numberOfScreens)
            setIsValid(false)
        else {
            setIsValid(true)
        }
    }, [ids])

    useEffect(() => {
        if (numberOfScreens < data.length && ids.length > numberOfScreens) {
            setIds(prev => prev.slice(0, numberOfScreens))
        }
        if (numberOfScreens > data.length)
            setIds([])

        setShowDeviceList(numberOfScreens < data.length)
    }, [numberOfScreens])

    return (
        <Dialog visible={openDialog.upgrade}
            breakpoints={{
                '960px': '95vw',
                '990px': '85vw',
            }}
            // style={{ width: "60%" }}
            modal
            header={t('payment.manage_subscription')}
            onHide={() => closeDialog()}
        >


            <div className="flex  flex-col flex-lg-row">
                <div className="col-12 col-lg-8 flex flex-column p-5">
                    <span className=' fs-5 fw-bold mb-2 col-12'>{t('payment.choose_plan')}</span>

                    {/* Packages */}
                    <div className='col-12  d-flex flex-column '>
                        <div className="col-12 fs-8 ms-1">
                            {t('payment.choose_plan_category')}
                        </div>
                        <div className="col-12 d-flex mt-1 flex-wrap">
                            <BillingCards
                                isActive={isActive}
                                payRate={selectedPricing?.period}
                                selectedPackage={selectedPackage}
                                setSelectedPackage={setSelectedPackage}
                            />



                        </div>
                    </div>

                    {/* Pricing  */}
                    <div className='col-12  d-flex flex-column mb-3'>
                        <div className="col-12 fs-8 ms-1">
                            {t('payment.choose_billing_cycle')}
                        </div>
                        <div className="col-12 d-flex mt-1 flex-wrap">
                            {
                                selectedPackage?.prices?.map((item, index) => {
                                    let _enable = (selectedPackage.title == companyDetails?.package?.title && isActive)
                                        || selectedPackage?.is_free || (isUpgrade && !isFree)

                                    return (
                                        <div key={item.id} onClick={() => _enable ? "" : setSelectedPricing(item)}
                                            className={`${item.is_free ? "text-light" : ""} col-4 d-flex justify-content-between pe-1`}
                                        >
                                            <div key={`${index}_${Math.random(20)}`} className={`field-radiobutton col-12 d-flex align-items-center position-relative  mb-1 mx-1 rounded p-2
                                                      ${selectedPricing?.period == item.period ? "border-2 pp-selected-border " : " border-1"}`} >
                                                {
                                                    item?.discount_percentage && !_enable ?
                                                        <>
                                                            <div className='discount_label fs-12' > </div>
                                                            <span className='discount'>{item.discount_percentage}%</span>
                                                        </>
                                                        :
                                                        <> </>
                                                }
                                                <RadioButton
                                                    inputId={item.id}
                                                    name="package"
                                                    className='d-flex align-items-center justify-content-center radio_bg'
                                                    value={item.id}
                                                    checked={selectedPricing?.period === item.period}
                                                    disabled={_enable}
                                                />
                                                <label htmlFor={item.id} className={`fs-8   ${_enable ? selectedPricing?.period == item.period ? "" : "text-light" : "cursor-pointer"}`}  >
                                                    {t('payment.months_label', { count: item.numeric_period })}
                                                    <br />
                                                    {`$ ${item.price} `}
                                                    <span className='fs-10 fw-light'>
                                                        {t('payment.per_screen')}
                                                    </span>

                                                </label>
                                            </div>
                                        </div>
                                    )
                                })}
                        </div>
                    </div>


                    {/* Number of Screens */}
                    <div className='col-12  d-flex flex-column mb-3'>
                        <div className="col-12 fs-8 ms-1">
                            {t('payment.number_of_screens')}
                            <Tooltip target={`.screen-no`} showDelay={100} className="fs-8" />
                            <i className="ml-3 fa-solid fa-circle-info screen-no" data-pr-position="bottom" data-pr-tooltip={
                                isUpgrade ?
                                    t('payment.screens_tooltip_upgrade')
                                    : t('payment.screens_tooltip_downgrade')
                            }></i>
                        </div>
                        <div className="col-5 d-flex  mt-1">
                            <InputNumber inputId="number_of_screens"
                                value={numberOfScreens}
                                onValueChange={(e) => onScreenChange("onChange", e.value)}
                                min={1}
                                className=''
                                disabled={isUpgrade && isActive && !isFree}
                            />
                            <div className='mx-2 arrow_container mt-1'>
                                <button
                                    disabled={isUpgrade && isActive && !isFree}
                                    onClick={() => onScreenChange("increment")}
                                >
                                    <i
                                        className={`fas fa-caret-square-up fs-4 ${(isUpgrade && isActive && !isFree)
                                            ? "text-light"
                                            : "text-primary cursor-pointer"
                                            }`}
                                    ></i>
                                </button>

                                <button
                                    disabled={numberOfScreens == 1 || (isUpgrade && isActive && !isFree)}
                                    onClick={() => onScreenChange("decrement")} >
                                    <i className={`fas fa-caret-square-down fs-4 ${(numberOfScreens == 1 || (isUpgrade && isActive && !isFree)) ? "text-light" : " text-primary cursor-pointer"}`}></i>
                                </button>
                            </div>
                        </div>
                        <div className="col-12 ">
                            {/* {
                                (showDeviceList && numberOfScreens < data?.length) ?
                                    <div className="field-checkbox mt-3 fs-6">
                                        <Checkbox inputId="binary" checked={selectDevice} className="me-2" onChange={(e) => { setSelectDevice(e.checked); setShowDeviceList(e.checked) }} />
                                        <label htmlFor="binary">Manually choose the screens to keep</label>
                                    </div>
                                    :
                                    <></>
                            } */}
                        </div>

                    </div>
                    {/* Amount  */}
                    <div className='col-12 d-flex flex-column mb-4 py-2 px-4 bg_gray'>
                        <div className="col-12 d-flex flex-wrap fs-8 ms-2">
                            <div className="col-8 mb-1">{t('payment.subtotal')}</div>
                            <div className="col-4 text-primary">$ {paymentData?.subtotal}</div>

                            <div className="col-8">{t('payment.fee')} <span className='fs-10'>( {selectedPackage?.tax}% VAT )</span></div>
                            <div className="col-4 text-primary">$ {paymentData?.tax}</div>
                            {isUpgrade && !isFree &&
                                (<><div className="col-8">{t('payment.remaining_credit')}</div>
                                    <div className="col-4 text-primary">$ -{(paymentData?.remainingCredit ?? 0)}</div>
                                </>)
                            }
                            {/*  */}
                        </div>
                        <hr className='my-2' />
                        <div className="col-12 d-flex ms-2 fs-6 fw-bold">
                            <div className="col-8 ">{t('payment.total')}</div>
                            <div className="col-4 text-primary">$ {(paymentData?.total)}</div>
                        </div>
                    </div>

                    {/* Form control */}
                    <div className='d-flex justify-content-center '>
                        <button type="reset" className="btn btn-label-secondary me-3 px-4 border "
                            onClick={closeDialog} data-bs-dismiss="modal" aria-label="Close">
                            {t('buttons.cancel')}
                        </button>
                        <button
                            disabled={actionLoading || selectedPackage?.is_free || (isActive && (selectedPackage?.title == companyDetails?.package?.title))}
                            type="button" className="btn btn-primary px-4" onClick={upgrade}>
                            {actionLoading
                                ? <Spinner as="span" animation="border" size="sm" role="status" className="mx-2" />
                                : hasStripeSubscription ? t('payment.change_plan') : t('payment.buy_package')
                            }
                        </button>
                    </div>
                </div>


                <div className="col-12 col-lg-4 flex flex-column p-5 bg_gray border-l">
                    {numberOfScreens < data?.length && ((!isUpgrade && isActive) || (!isActive)) ? (

                        <>
                            {/* Device List*/}
                            <span className='fs-5 fw-bold mb-2'>{t('payment.choose_screens_to_keep')}</span>

                            {data?.length === 0 && isFetching ? (
                                <ProgressSpinner style={{ width: "60px", height: "60px" }} strokeWidth="3" fill="var(--surface-ground)" animationDuration="1s" />
                            ) : (
                                <div className={`d-flex flex-column scroll_container scroll_div px-2 w-100`}>
                                    {data?.map((item, index) => {
                                        let _disabled = numberOfScreens === ids.length && ids.indexOf(`${item.id}`) === -1;

                                        return (
                                            <div key={`${item.type}-${index}`} className="col-12 d-flex align-items-center justify-content-between my-1 pb-2">
                                                <div className="col-2 col-sm-1 pe-2">
                                                    <Checkbox inputId={item.id} name="media"
                                                        disabled={_disabled}
                                                        className='me-3'
                                                        value={item.id}
                                                        onChange={onDevicesChange}
                                                        checked={ids.indexOf(`${item.id}`) !== -1}
                                                    />
                                                </div>
                                                <label htmlFor={item.id} className={`col-10 col-sm-11 d-flex text-truncate ${_disabled ? "text-light" : ""}`}>
                                                    {item.name}
                                                </label>
                                            </div>
                                        );
                                    })}

                                    {isFetching && (
                                        <ProgressSpinner style={{ width: '60px', height: '60px', opacity: 0.1 }} strokeWidth="3" fill="var(--surface-ground)" animationDuration="1s" />
                                    )}
                                </div>
                            )}

                            {!isValid && (
                                <div className="text-danger">
                                    {t('payment.select_more_devices', { count: numberOfScreens - ids?.length })}
                                </div>
                            )}
                        </>

                    ) : (
                        <>
                            {/* Features List*/}
                            <span className='fs-5 fw-bold mb-2'>{t('payment.included_with', { title: selectedPackage?.title })}</span>
                            <FeaturesList selectedPackage={selectedPackage} />
                        </>
                    )}
                </div>
            </div>
        </Dialog >
    )
}

export default UpgradeDialog